import { Form } from '@/components'
import PropTypes from 'prop-types'
import React from 'react'

function DonorsGroup({
  donors,
  values,
  setFieldValue,
  fieldName,
  title,
}) {
  if (!donors.length) return null

  const excludedDonorIds = values[fieldName] || []
  const donorIds = donors.map((donor) => donor.id)
  const allChecked = donorIds.every((id) => !excludedDonorIds.includes(id))

  function toggleDonor(id) {
    const next = excludedDonorIds.includes(id)
      ? excludedDonorIds.filter((item) => item !== id)
      : [...excludedDonorIds, id]
    setFieldValue(fieldName, next)
  }

  function checkAll() {
    const next = excludedDonorIds.filter((id) => !donorIds.includes(id))
    setFieldValue(fieldName, next)
  }

  function uncheckAll() {
    const next = [
      ...excludedDonorIds,
      ...donorIds.filter((id) => !excludedDonorIds.includes(id)),
    ]
    setFieldValue(fieldName, next)
  }

  return (
    <>
      <div className="divider text-center" data-content={title} />
      <Form.Group>
        <button
          type="button"
          className="btn btn-link btn-sm p-0"
          onClick={allChecked ? uncheckAll : checkAll}
        >
          {allChecked ? 'Desmarcar todos' : 'Marcar todos'}
        </button>
      </Form.Group>
      {donors.map((donor) => {
        const checked = !excludedDonorIds.includes(donor.id)

        return (
          <Form.Group key={donor.id}>
            <Form.Check>
              <input
                type="checkbox"
                checked={checked}
                onChange={() => toggleDonor(donor.id)}
              />
              <i className="form-icon" />
              {donor.fullName}
              {' '}
              ({donor.donationsCount})
            </Form.Check>
          </Form.Group>
        )
      })}
    </>
  )
}

DonorsGroup.propTypes = {
  donors: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    fullName: PropTypes.string,
    donationsCount: PropTypes.number,
  })).isRequired,
  values: PropTypes.objectOf(PropTypes.any).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  fieldName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default DonorsGroup
